import React, { Component } from 'react';
import moment from 'moment-timezone';
import { DateRangePicker, DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './ReactDateRangeWrapper.css'; //overridden styles
import { Dialog, Button, IconButton } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Fade from '@material-ui/core/Fade';
import Slide from '@material-ui/core/Slide';
import { DateRanges, CustomRangeObject } from './DateRanges';
import { AppTheme, AppStyles } from '../../../styles/AppTheme';
import { AppHelper } from '../../../helpers/AppHelper';
import { StyleSheet, css } from 'aphrodite';
import { isSameDay } from 'date-fns/esm';
import { AppButton } from '../AppButton';
import { CommonTheme } from '../../../styles/Styles';
import { Helper } from '../../helpers/Helper';

/*
  Usage:

  <ReactDateRangeWrapper key='dateTimeRangePicker'
    onDateRangeChange={this.onDateRangeChange}
    // onDateRangeChange({startDate, endDate, id}) { }
    initialRange={{
      id: 'today', // check below for ids
      // startDate: new Date(), // required when id === 'custom'
      // endDate: new Date(), // required when id === 'custom'
    }}
  />

  Possible ids 'custom', 'today', 'yesterday', 'last_7d', 'last_30d',
  'last_90d', 'last_6m', 'last_12m', 'all_time',

  startDate and endDate are mandatory when id === 'custom'

  id --> corresponds to date range defined in ./DateRanges.js file
  More default date ranges can be added in ./DateRanges.js file

  check DateRangePicker corresponding element's classes in
  dev tools and override them in ./ReactDateRangeWrapper.css
  Also check styles of DateRangePicker in react-date-range/dist/theme/default.css

  All dates are local dates from Date object. If required
  use timezone offsets to convert into desired timezone dates in your code
*/

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const isSameDayNullSafe = (date1, date2) => {
  return (date1 == null && date2 == null) || (date1 != null && date2 != null && isSameDay(date1, date2))
}

function isSameDateValue(d1, d2) {
  if (d1 == null && d2 == null) return true
  if (d1 == null || d2 == null) return false
  return new Date(d1).getTime() === new Date(d2).getTime()
}

export class ReactDateRangeWrapper extends Component {
  constructor(props) {
    super(props)
    this.isMobileView = Helper.isMobileView()
    const dIRange = DateRanges.find(range => range.id === props.initialRange.id) || DateRanges[0]
    if (props.initialRange.id === 'custom') {
      CustomRangeObject.startDate = props.initialRange.startDate
      CustomRangeObject.endDate = props.initialRange.endDate
    }
    const { startDate, endDate, id, label } = dIRange.range()
    this.state = {
      isOpen: false,

      startDate,
      endDate,
      displayRangeId: id,
      displayRangeLabel: label,

      range: {
        startDate,
        endDate,
        key: 'r1' // range key, we use single date range.
      },
      selectedDefinedRangeId: id,
      selectedDefinedRangeLabel: label,
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.initialRange || !prevProps.initialRange) {
      return
    }

    const idChanged = this.props.initialRange.id !== prevProps.initialRange.id
    const startChanged = !isSameDayNullSafe(this.props.initialRange.startDate, prevProps.initialRange.startDate)
    const endChanged = !isSameDayNullSafe(this.props.initialRange.endDate, prevProps.initialRange.endDate)

    if (!idChanged && !startChanged && !endChanged) {
      return
    }

    if (this.props.initialRange.id === 'custom' && (!this.props.initialRange.startDate || !this.props.initialRange.endDate)) {
      return
    }

    const dIRange = DateRanges.find(function(range) {
      return range.id === this.props.initialRange.id
    }.bind(this)) || DateRanges[0]

    if (this.props.initialRange.id === 'custom') {
      CustomRangeObject.startDate = this.props.initialRange.startDate
      CustomRangeObject.endDate = this.props.initialRange.endDate
    }

    let rangeData

    if (this.props.initialRange.id === 'custom') {
      rangeData = {
        startDate: this.props.initialRange.startDate,
        endDate: this.props.initialRange.endDate,
        id: 'custom',
        label: 'Custom'
      }
    } else {
      rangeData = dIRange.range()
    }

    const startDate = rangeData.startDate
    const endDate = rangeData.endDate
    const id = rangeData.id
    const label = rangeData.label

    const isSameState = isSameDateValue(this.state.startDate, startDate) && isSameDateValue(this.state.endDate, endDate) && this.state.displayRangeId === id

    if (isSameState) {
      return
    }

    this.setState({
      startDate: startDate,
      endDate: endDate,
      displayRangeId: id,
      displayRangeLabel: label,
      range: {
        key: this.state.range.key,
        startDate: startDate,
        endDate: endDate
      },
      selectedDefinedRangeId: id,
      selectedDefinedRangeLabel: label
    })
  }

  openDateRangePicker = () => {
    if (this.props.disabled) return;
    this.setState({
      isOpen: true
    });
  }
  closeDateRangePicker = () => {
    this.setState({
      isOpen: false,
      range: {
        ...this.state.range,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
      },
      selectedDefinedRangeId: this.state.displayRangeId,
      selectedDefinedRangeLabel: this.state.displayRangeLabel
    });
  }
  applyDateRangePicker = () => {
    const { startDate, endDate } = this.state.range
    const id = this.state.selectedDefinedRangeId
    const label = this.state.selectedDefinedRangeLabel
    this.setState({
      isOpen: false,
      startDate,
      endDate,
      displayRangeId: id,
      displayRangeLabel: label
    });
    if (this.props.onDateRangeChange) {
      this.props.onDateRangeChange({
        startDate,
        endDate,
        id: id,
        label: label
      })
    }
  }
  getDefinedRange = (range) => {
    const rangesToMatch = this.getStaticRanges().filter((r) => r.id !== 'custom')
    for (let i = 0; i < rangesToMatch.length; i++) {
      const definedRange = rangesToMatch[i].range()
      if (
        isSameDayNullSafe(range.startDate, definedRange.startDate) &&
        isSameDayNullSafe(range.endDate, definedRange.endDate)
      ) {
        CustomRangeObject.startDate = range.startDate
        CustomRangeObject.endDate = range.endDate
        const d = rangesToMatch[i].range()
        range.startDate = d.startDate
        range.endDate = d.endDate
        return d
      }
    }

    CustomRangeObject.startDate = moment(range.startDate).startOf('day')
    CustomRangeObject.endDate = moment(range.endDate).endOf('day')
    range.startDate = moment(range.startDate).startOf('day')
    range.endDate = moment(range.endDate).endOf('day')
    return CustomRangeObject
  }

  onChange = (range) => {
    if(range && range.r1 && (range.r1.id === 'all_time' || (range.r1.id === 'custom' && !moment(range.r1.startDate).isValid() && !moment(range.r1.endDate).isValid()))) {
      this.setState({
        range: {
          ...range.r1,
          startDate: null,
          endDate: null
        },
        selectedDefinedRangeId: range.r1.id,
        selectedDefinedRangeLabel: ''
      })
    } else if(range && range.r1) {
      let { startDate, endDate } = range.r1

      if(!['due','overdue', 'upcoming'].includes(range.r1.id)) {
        if (startDate && endDate && startDate > endDate) {
          [startDate, endDate] = [endDate, startDate]
        } else if (!startDate && endDate) {
          startDate = endDate
        }
      }

      const { id, label } = this.getDefinedRange({
        ...range.r1,
        startDate,
        endDate,
      })

      this.setState({
        range: {
          ...range.r1,
          startDate,
          endDate,
        },
        selectedDefinedRangeId: id,
        selectedDefinedRangeLabel: label,
      })
    }
  }

  getStaticRanges() {
    let staticRanges = DateRanges
    if(this.props && Array.isArray(this.props.availableDateRanges)) {
      staticRanges = DateRanges.filter((range)=> this.props.availableDateRanges.includes(range.id))
    }
    return staticRanges
  }

  render() {
    const { startDate, endDate, displayRangeId, displayRangeLabel } = this.state
    const displayFormat = this.props.dateDisplayFormat || 'Do MMM YYYY'
    let displayText = displayRangeLabel
    if (!displayText || (displayText === 'Custom')) {
      const start = startDate && moment.tz(startDate,this.props.timezone).format(displayFormat)
      const end = endDate && moment.tz(endDate,this.props.timezone).format(displayFormat)
      displayText = (start && end) ? `${start} - ${end}` : ''
    }
    const modalTitle = this.props.title || 'Pick Date Range'
    const hasManyPresets = this.getStaticRanges().length > 8
    const useScrollableLayout = hasManyPresets
    const dateRangePicker = (
      <DateRangePicker
        ranges={[this.state.range]}
        onChange={this.onChange}
        staticRanges={this.getStaticRanges()}
        showPreview={true}
        inputRanges={[]}
        rangeColors={this.props.rangeColors || [AppTheme.primaryColor]}
        dateDisplayFormat={displayFormat}
      />
    )
    const applyButton = (
      <AppButton
        key={'applyButton'}
        onClick={this.applyDateRangePicker}
        buttonText={'apply'}
        buttonStyle={Styles.applyButton}
        buttonTextStyle={Styles.applyButtonText}
        progressIconSize={16}
      />
    )
    return (
      <div>
        <div className={this.props.disabled ? css(Styles.displayField, this.props.displayFieldStyle, Styles.displayFieldDisabled) : css(Styles.displayField, this.props.displayFieldStyle)} onClick={!this.props.disabled && this.openDateRangePicker}>
          {displayText}
          <IconButton size='small' className={css(Styles.arrowButton)} disabled={this.props.disabled}>
            {this.state.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        </div>

        <Dialog
          open={this.state.isOpen}
          aria-labelledby={modalTitle}
          TransitionComponent={window.innerWidth < 768 ? Transition : Fade}
          classes={{
            root: css(Styles.customRoot, useScrollableLayout && Styles.customRootNested),
            paper: css(Styles.customPaper, useScrollableLayout && Styles.customPaperScrollableMobile, AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar),
          }}
        >
          <div className={css([Styles.modalHeader, AppStyles.modalHeader, useScrollableLayout && Styles.modalHeaderPinned])}>
            <div className={css(Styles.modalTitle)}>{modalTitle}</div>
            <button className={css(Styles.modalCloseButton)} onClick={this.closeDateRangePicker} disabled={this.state.inProcess}>
              <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
                <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
              </svg>
            </button>
          </div>
          {useScrollableLayout ? (
            <React.Fragment>
              <div className={css(Styles.modalContentScroll)}>
                <div className={`${css(Styles.dateRangePickerMobileContainer)} dateRangePickerManyPresets`}>
                  {dateRangePicker}
                </div>
              </div>
              <div className={css(Styles.applyContainer, Styles.applyContainerPinned)}>
                {applyButton}
              </div>
            </React.Fragment>
          ) : (
            <div className={css(Styles.modalContent)}>
              <div className={this.isMobileView && css(Styles.dateRangePickerMobileContainer)}>
                {dateRangePicker}
              </div>
              <div className={css(Styles.applyContainer)}>
                {applyButton}
              </div>
            </div>
          )}

        </Dialog>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  displayField: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    minWidth: 200,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden',
    boxSizing: 'border-box',
    padding: '12px 0px 12px 20px',
    color: CommonTheme.textColor,
    fontSize: 16,
    fontWeight: 'initial',
    '@media (max-width: 1024px)': {
      fontSize: 10,
      minWidth: 0,
      width: 150,
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
  displayFieldDisabled: {
    backgroundColor: AppTheme.secondaryColor,
    color: '#808080',
  },
  arrowButton: {
    marginLeft: 'auto',
    // '@media (max-width: 1024px)': {
    padding: 0,
    // }
  },
  modalHeader: {
    // backgroundColor: 'whitesmoke',
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: 20,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalTitle: {
    color: CommonTheme.textColor,
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // marginRight: 28,
    flex: 1,
    '@media (max-width: 767px)': {
      fontSize: 20,
      marginRight: 43,
    }
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 30,
    paddingRight: 30,
    minHeight: 400,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
      minHeight: 200,
    }
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 23,
    // right: 30,
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none'
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8
  },
  button: {
    boxShadow: 'none',
    marginLeft: 10,
    backgroundColor: AppTheme.primaryColor,
  },
  applyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 0px'
  },
  applyContainerPinned: {
    flexShrink: 0,
    paddingLeft: 30,
    paddingRight: 30,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    },
  },
  modalHeaderPinned: {
    flex: 'unset',
    flexShrink: 0,
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: AppTheme.secondaryBg,
  },
  modalContentScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'scroll',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
    WebkitOverflowScrolling: 'touch',
    paddingLeft: 30,
    paddingRight: 30,
    '::-webkit-scrollbar': {
      width: 10,
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.28)',
      borderRadius: 5,
    },
    '::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
    },
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    },
  },
  customPaperScrollableMobile: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '85vh',
    overflow: 'hidden',
    paddingTop: 'env(safe-area-inset-top, 0px)',
    '@media (max-width: 767px)': {
      maxHeight: '85dvh',
    },
  },
  customRootNested: {
    zIndex: 13002,
  },
  dateRangePickerMobileContainer:{
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 8px',
    borderRadius: 0,
  },
  customRoot: {
    zIndex: 13000
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 767px)': {
      // borderRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      width: '100%',
      bottom: 0,
      position: 'fixed',
      margin: 0,
      marginTop: 0,
      maxHeight: '100%'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    },
  },
  applyButton: {
    backgroundColor: AppTheme.primaryColor,
    borderRadius: AppTheme.borderRadius,
    display: 'flex',
    alignItems: 'center',
    height: 54,
    minWidth: 150,
    // flex: 1,
    padding: 13,
    fontSize: 16,
    textTransform: 'capitalize',
    color: AppTheme.secondaryBg,
    '@media (max-width: 1024px)': {
      minWidth: 125,
      height: 50
    }
  },
  applyButtonText: {
    color: AppTheme.secondaryBg,
  },
})
